import styled from '@emotion/styled'

import { BodyM, BodyP, HeadingXS } from '@/components/Typography'

import { CONFIG } from '@/styles/emotion.config'

import Link from './Link'

export interface AgencyItem {
  id: string
  title: string
  adreess: string
  openingHours: string
  link: string
}

interface AgencyProps {
  agency: AgencyItem
}

const AgencyStyles = styled.div({
  minWidth: '19rem',
  borderRadius: 'var(--radii-default)',
  flex: '1',
  padding: '1rem',
  margin: '0.5rem',
  backgroundColor: 'rgba(var(--theme-snow))',

  '& .agency-title': {
    marginBottom: '0.5rem',
  },
  '& .agency-address-container': {
    minHeight: '4.5rem',
  },
  '& .agency-opening-hours': {
    marginTop: '1rem',
  },
  [CONFIG.media.lg]: {
    maxWidth: '19rem',
  },
})

export const Agency = ({ agency: { title, adreess, openingHours, link } }: AgencyProps) => (
  <AgencyStyles>
    <HeadingXS className="agency-title">{title}</HeadingXS>
    <BodyM className="agency-address-container">{adreess}</BodyM>
    <BodyP tag="p" emphasys className="agency-opening-hours">
      Horário de atendimento:
    </BodyP>
    <BodyP>{openingHours}</BodyP>
    <Link source={link} />
  </AgencyStyles>
)
